interface Number {
	toHex(): string;
}

if (Number.prototype.toHex === undefined) {
	Number.prototype.toHex = function () {
		return this.toString(16).padStart(2, '0');
	};
}
